<template>
  <ValidationObserver ref="form" slim>
    <div v-if="tapRequestId && loaded" class="row">
      <slot name="Observations" />
      <div class="col-12">
        <FacilitatorInquiries
          :submitted-date="model.submittedDate"
          :person-who-attends="personWhoAttends"
          :can-delete="canDeleteFacilitatorInquiries"
          :is-read-only="
            readonly || sectionsStates[enums.sections['Consultas']].readonly
          "
          :value="model.inquiries"
          title="Consultas"
        />
      </div>

      <div class="col-12">
        <SectionTitle
          :has-line="true"
          content="Luego de analizar la información brindada, la gestión del facilitador de educación especial de la ORE fue:"
        />
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Coordinar Reunion ORE Escuela']]
                .readonly
          "
          :active.sync="collapseTogglers.schoolMeetingSchedule"
          activator-text="Coordinar una fecha para reunión con el equipo de trabajo de la escuela."
          @update:active="checkSchoolMeetingDelete($event)"
        >
          <div class="bg-light-gray p-3">
            <ValidationProvider
              name="Reunión ORE Escuela"
              v-slot="{ errors, validate: _validate2 }"
              :rules="{
                required:
                  collapseTogglers.cseeDirectorConsult || validate || false,
              }"
            >
              <input
                type="hidden"
                :required="collapseTogglers.cseeDirectorConsult || validate"
                :value="
                  model.schoolMeetingSchedule &&
                  model.schoolMeetingSchedule.length > 0
                    ? '1'
                    : ''
                "
              />
              <ScheduleOREMeeting
                ref="schoolORE"
                :tap-request-id="tapRequestId"
                :tap-request-status="model.status"
                :items.sync="model.schoolMeetingSchedule"
                :consultation-process="true"
                :delete="meetingOptions.schoolMeeting.delete"
                :submitted="
                  readonly ||
                    sectionsStates[
                      enums.sections['Coordinar Reunion ORE Escuela']
                    ].readonly
                "
                meeting-type="Escuela"
                @input="runValidation(_validate2)"
              />
              <Error
                v-if="errors && errors[0]"
                variant="no-border"
                message="Favor coordinar una fecha para reunión con el equipo de trabajo de la escuela."
              />
            </ValidationProvider>
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Coordinar Reunion ORE COMPU']]
                .readonly
          "
          :active.sync="collapseTogglers.compuMeetingSchedule"
          activator-text="Coordinar una fecha para reunión con el COMPU."
          @update:active="checkCompuMeetingDelete($event)"
        >
          <div class="bg-light-gray p-3">
            <ValidationProvider
              ref="cseeDirectorConsultValidations"
              name="Reunión ORE COMPU"
              v-slot="{ errors, validate: _validate3 }"
              :rules="{
                required:
                  collapseTogglers.cseeDirectorConsult || validate || false,
              }"
            >
              <input
                type="hidden"
                :required="collapseTogglers.cseeDirectorConsult || validate"
                :value="model.compuMeetingSchedule.length > 0 ? '1' : ''"
              />
              <ScheduleOREMeeting
                ref="compuORE"
                :tap-request-id="tapRequestId"
                :tap-request-status="model.status"
                :items.sync="model.compuMeetingSchedule"
                :consultation-process="true"
                meeting-type="COMPU"
                :submitted="
                  readonly ||
                    sectionsStates[
                      enums.sections['Coordinar Reunion ORE COMPU']
                    ].readonly
                "
                @input="runValidation(_validate3)"
              />
              <Error
                v-if="errors && errors[0]"
                variant="no-border"
                message="Favor coordinar una fecha para reunión con el COMPU."
              />
            </ValidationProvider>
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Recomendar Reunion COMPU']]
                .readonly
          "
          :active.sync="collapseTogglers.compuRecommendations"
          activator-text="Recomendar que el COMPU se reúna para:"
          @update:active="deleteCOMPURecommendation($event)"
        >
          <div class="bg-light-gray p-3">
            <ValidationProvider
              name="Recomendaciones COMPU"
              v-slot="{ errors, validate: _validate4 }"
              :rules="{
                required: collapseTogglers.compuRecommendations || validate,
              }"
            >
              <input
                type="hidden"
                :required="collapseTogglers.compuRecommendations || validate"
                :value="
                  model.compuRecommendations &&
                  model.compuRecommendations.length
                    ? '1'
                    : ''
                "
              />
              <ORERecommendations
                :disabled="
                  readonly ||
                    sectionsStates[enums.sections['Recomendar Reunion COMPU']]
                      .readonly
                "
                :questionnaire="catalogs.oreRecommendations.questionnaire"
                :answers.sync="model.compuRecommendations"
                :validate="collapseTogglers.compuRecommendations || validate"
                @input="runValidation(_validate4)"
              />
              <Error
                v-if="errors && errors[0]"
                variant="no-border"
                message="Favor seleccionar al menos una opción que recomiende que el COMPU se reúna."
              />
            </ValidationProvider>
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[
                enums.sections['Búsqueda Localizaciones Disponibles']
              ].readonly
          "
          :active.sync="collapseTogglers.schoolRecommendations"
          activator-text="Realizar el proceso de búsqueda de localizaciones disponibles:"
          @update:active="deleteSchoolRecommendation($event)"
        >
          <div class="bg-light-gray p-3">
            <AvailableLocations
              :readonly="
                readonly ||
                  sectionsStates[
                    enums.sections['Búsqueda Localizaciones Disponibles']
                  ].readonly
              "
              :academic-year-id="model.academicYearId"
              :region="model.region"
              :municipality="model.municipality"
              :tap-request-type-id="tapRequestTypeId"
              :items.sync="model.schoolRecommendations"
              :validate-options="
                collapseTogglers.cseeDirectorConsult || validate
              "
              :validate-items="collapseTogglers.cseeDirectorConsult || validate"
            />
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Referir Consulta Director CSEE']]
                .readonly
          "
          :active.sync="collapseTogglers.cseeDirectorConsult"
          activator-text="Referir consulta al director de CSEE:"
          @update:active="checkReferredToDirector($event)"
        >
          <ValidationProvider
            name="Justificación referido al Director de CSEE"
            v-slot="{ errors }"
            rules="required"
          >
            <input
              type="hidden"
              required
              :value="
                model.cseeDirectorConsult && model.cseeDirectorConsult.trim()
                  ? '1'
                  : ''
              "
            />
            <div class="bg-light-gray p-3">
              <CustomTextArea
                v-model="model.cseeDirectorConsult"
                label="Justificar referido al Director de CSEE"
                :regular-label="true"
                :maxlength="3000"
                :show-char-count="true"
                :count-classes="['d-block text-right']"
                :disabled="
                  readonly ||
                    sectionsStates[
                      enums.sections['Referir Consulta Director CSEE']
                    ].readonly
                "
              />

              <Error
                v-if="errors[0] && errors[0]"
                variant="no-border"
                message="Favor escribir justificación de referido al director del CSEE."
              />
            </div>
          </ValidationProvider>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <ValidationProvider
          ref="documentValidation"
          name="Documentos"
          v-slot="{ errors }"
          vid="document"
          :rules="{
            required:
              (!sectionsStates[enums.sections['Documentos']].readonly &&
                collapseTogglers.cseeDirectorConsult) ||
              validate
                ? { allowFalse: false }
                : false,
          }"
          :custom-messages="{ required: 'Favor anejar un documento.' }"
        >
          <input
            type="hidden"
            :required="
              (!sectionsStates[enums.sections['Documentos']].readonly &&
                collapseTogglers.cseeDirectorConsult) ||
                validate
            "
            :value="
              getDocumentData &&
              getDocumentData.files &&
              getDocumentData.files.length > 0
                ? '1'
                : ''
            "
          />
          <Documents
            :key="documentLength"
            :disabled="
              readonly || sectionsStates[enums.sections['Documentos']].readonly
            "
            :documents="getDocumentData"
            :document-types="document.documentTypes"
            :invalid-types="getInvalidDocumentTypes"
            :message="
              'En caso de tener el documento de Propuesta de Servicios es sugerido subirlo al sistema. No es requerido para este análisis.'
            "
            :center-title-header="'Documentos'"
            @input="runDocumentValidation()"
            @files="
              gettingDocument($event);
              runDocumentValidation();
            "
          />

          <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
        </ValidationProvider>
      </div>

      <div
        v-if="showServicesSummary && servicesSummary.length > 0"
        class="col-12"
      >
        <ServicesSummary
          :services="servicesSummary"
          :collections="servicesSummaryCollections"
          :readonly="true"
          :hide-total="false"
        />
      </div>
      <div v-else-if="showServicesSummary" class="col-12">
        <b-alert show variant="info" class="mb-0">Sin servicios</b-alert>
      </div>

      <div class="my-3 col-12">
        <Requesters
          keep-signed
          :limit-new-signatures-to="1"
          role-label="Puesto"
          :allow-add-more="false"
          :submitted="
            readonly ||
              sectionsStates[enums.sections['Funcionarios Solicitan']].readonly
          "
          :requesters="model.requesters"
          :positions-list="requestersPositionsList"
          :cannot-edit-name="true"
          :use-role="true"
          @input="runDocumentValidation()"
        />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import {
  FacilitatorInquiries,
  ScheduleOREMeeting,
  scheduleOREMeetingApi,
  ORERecommendations,
  Documents,
  Requesters,
} from '@/components/pei/ubication-tech-assistance/_components';
import AvailableLocations from '../AvailableLocations';
import SectionTitle from 'SectionTitle';
import CollapsibleItem from '../CollapsibleItem';
import CustomTextArea from 'CustomTextArea';

import {
  getFacilitatorAnalysis,
  getDocumentTypesByCode,
  deleteCOMPURecommendation,
  deleteSchoolRecommendation,
  deleteCSEEConsult,
} from '@/services/api/tapRequest.api';
import Error from 'custom-error';
import alert from 'utils/mixins/alert.mixin';
import store from '@/store/index';
import { getORERecommendations } from '@/components/pei/ubication-tech-assistance/_api';
import {
  tapRequestTypesEnum,
  tapRequestQuestionSectionsEnum,
  tapRequestStatusesEnum,
} from '@/components/pei/ubication-tech-assistance/_types';
import { UTA_MANAGEMENT_SECTION_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';
import ServicesSummary from '@/components/pei/ubication-tech-assistance/management/_components/CentralLevelAnalysis/components/ServicesSummary/Main.vue';

export default {
  name: 'FacilitatorAnalysis',
  mixins: [alert],
  inject: { studentSieId: { default: 0 }, tapRequestId: { default: 0 } },
  components: {
    SectionTitle,
    CollapsibleItem,
    FacilitatorInquiries,
    ScheduleOREMeeting,
    ORERecommendations,
    AvailableLocations,
    Documents,
    Requesters,
    Error,
    CustomTextArea,
    ServicesSummary,
  },
  props: {
    readonly: { type: Boolean, default: false },
    modelToSave: { type: Object, default: () => {} },
    validate: { type: Boolean, default: false },
    sectionsStates: { type: Object, default: () => ({}) },
    showServicesSummary: { type: Boolean, default: false },
    servicesSummary: { type: Array, default: () => [] },
    servicesSummaryCollections: { type: Object, default: () => ({}) },
  },
  data: () => ({
    documentLength: 0,
    enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
    loaded: false,
    tapRequestStatusesEnum,

    collapseTogglers: {
      schoolMeetingSchedule: false,
      compuMeetingSchedule: false,
      compuRecommendations: false,
      cseeDirectorConsult: false,
      schoolRecommendations: false,
    },
    meetingOptions: {
      schoolMeeting: {
        canDelete: true,
      },
      compuMeeting: {
        canDelete: true,
      },
    },
    document: {
      documentTypes: [],
      // Variables to save component data.
      data: {
        files: [],
        types: [],
      },
    },
    tapRequestTypeId: tapRequestTypesEnum.FacilitatorAnalysis,
    model: {
      academicYearId: null,
      region: null,
      municipality: null,
      schoolMeetingSchedule: [],
      compuMeetingSchedule: [],
      compuRecommendations: [],
      id: null,
      inquiries: [],
      status: null,
      studentSieId: null,
      submittedDate: null,
      documents: [],
      requesters: [],
      cseeDirectorConsult: null,
      schoolRecommendations: [],
    },
    FacilitatorSaveDTO: {},
    catalogs: {
      oreRecommendations: {
        questionnaire: {},
      },
    },
    requestersPositionsList: [],
  }),
  computed: {
    personWhoAttends() {
      return (
        this.userProfile.firstname + ' ' + this.userProfile.lastpaternalname
      );
    },
    getDocumentData() {
      return this.document.data;
    },
    getInvalidDocumentTypes() {
      const documentTypeEnum = {
        propuestaServicios: 191,
        documentoPEI: 192,
      };
      const invalidTypes = [];

      if (
        this.document.data.types.filter(
          (x) => x === documentTypeEnum.propuestaServicios
        ).length > 0
      ) {
        invalidTypes.push(documentTypeEnum.propuestaServicios);
      }

      if (
        this.document.data.types.filter(
          (x) => x === documentTypeEnum.documentoPEI
        ).length >= 2
      ) {
        invalidTypes.push(documentTypeEnum.documentoPEI);
      }

      return invalidTypes;
    },
    canDeleteFacilitatorInquiries() {
      return store.getters.HasPermission('facilitator.inquiries.delete');
    },
  },
  methods: {
    runValidation(validateFn) {
      if (validateFn && typeof validateFn === 'function') {
        validateFn();
      }
    },
    runDocumentValidation() {
      const ref = this.$refs.documentValidation;
      if (ref && typeof ref.validate === 'function') {
        const hasFiles =
          this.document.data &&
          this.document.data.files &&
          this.document.data.files.length > 0;
        ref.validate(hasFiles);
      }
    },
    async getDocumentTypesByCode(code) {
      const { data } = await getDocumentTypesByCode(code);
      data.forEach((element) => {
        this.document.documentTypes.push({
          id: element.id,
          name: element.name,
        });
      });
    },
    async gettingDocument(data) {
      this.document.data = data;
    },
    fillDocuments() {
      this.document.data = {
        files: [],
        types: [],
      };
      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents.forEach((element) => {
          this.document.data.files.push({
            name: element.filename,
            peiStatus: element.peiStatus,
            pei: element.peiId,
            documentType: element.document.documentTypeId,
            documentTypeName: element.document.documentTypeName,
            id: element.documentId,
            inServer: true,
            isReport: element.isReport,
            readOnly: element.readOnly,
            createdDate: element.createdDate,
            userName: element.userName,
            userFullName: element.userFullName,
            isAmendmentDocument: element.isAmendmentDocument,
          });
          this.document.data.types.push(element.document.documentTypeId);
        });
      }
      this.documentLength++;
    },
    async getData() {
      const { data } = await getFacilitatorAnalysis(this.tapRequestId);
      this.model = {
        ...this.model,
        ...data,
        document: this.document,
        inquiries: data.inquiries || [],
        schoolRecommendations: data.recomendations || [],
        referredToDirector: this.collapseTogglers.cseeDirectorConsult,
        requesters: data.staffMembers.map((c) => {
          return {
            id: c.id,
            status: c.status,
            userName: c.userName,
            name: c.fullName,
            email: c.email,
            phone: c.telephoneNumber,
            signed: c.signed,
            role: {
              id: c.rolId,
              name: c.rol,
            },
            signDate: c.signDate,
          };
        }),
      };

      this.$emit('update:modelToSave', this.model);
      this.fillDocuments();
    },
    async getCatalogs() {
      const data = await getORERecommendations(
        tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisFacilitador
      );
      this.catalogs.oreRecommendations.questionnaire = data;
    },
    async getPositions() {
      const { data } = await this.$ApiGet('/api/signature/availablepositions');
      this.requestersPositionsList = data;
    },
    initTogglers() {
      this.collapseTogglers.compuMeetingSchedule = !!this.model
        .compuMeetingSchedule.length;
      this.collapseTogglers.compuRecommendations = !!this.model
        .compuRecommendations.length;
      this.collapseTogglers.schoolMeetingSchedule = !!this.model
        .schoolMeetingSchedule.length;
      this.collapseTogglers.schoolRecommendations = !!this.model
        .schoolRecommendations.length;
      this.collapseTogglers.cseeDirectorConsult = !!this.model
        .cseeDirectorConsult;
    },
    setMeetingOptions() {
      if (
        this.model.schoolMeetingSchedule &&
        this.model.schoolMeetingSchedule.length > 0
      ) {
        const today = new Date();
        let schoolMeetingDates = this.model.schoolMeetingSchedule.map(
          (m) => new Date(m.date)
        );

        this.meetingOptions.schoolMeeting.canDelete = !schoolMeetingDates.some(
          (date) => new Date(date) < today
        );
      }

      if (
        this.model.compuMeetingSchedule &&
        this.model.compuMeetingSchedule.length > 0
      ) {
        const today = new Date();
        let compuMeetingDates = this.model.compuMeetingSchedule.map(
          (m) => new Date(m.date)
        );

        this.meetingOptions.compuMeeting.canDelete = !compuMeetingDates.some(
          (date) => new Date(date) < today
        );
      }
    },
    async checkSchoolMeetingDelete(value) {
      if (!value && this.model.schoolMeetingSchedule.length > 0) {
        if (this.meetingOptions.schoolMeeting.canDelete) {
          const deleteResponse = await alert.methods.ShowCancelModal(
            'Confirmación',
            'Usted cuenta con reuniones coordinadas. ¿Está seguro que desea eliminar las reuniones coordinadas para reunión con el equipo de trabajo de la escuela?',
            'Sí',
            'No'
          );
          if (deleteResponse) {
            this.model.schoolMeetingSchedule.forEach((i) =>
              scheduleOREMeetingApi.remove(i.id)
            );
            this.model.schoolMeetingSchedule = [];
          } else {
            this.collapseTogglers.schoolMeetingSchedule = true;
          }
        } else {
          alert.methods.ShowToast(
            'Alerta',
            'Usted cuenta con reuniones coordinadas antes de la fecha actual, no es posible descartar la gestión del facilitador de educación especial de la ORE.',
            'error',
            () => (this.collapseTogglers.schoolMeetingSchedule = true)
          );
        }
      }
    },
    checkReferredToDirector(value) {
      this.model.referredToDirector = value;
      if (!value) {
        this.model.cseeDirectorConsult = null;
      }
    },
    async checkCompuMeetingDelete(value) {
      if (!value && this.model.compuMeetingSchedule.length > 0) {
        if (this.meetingOptions.compuMeeting.canDelete) {
          const deleteResponse = await alert.methods.ShowCancelModal(
            'Confirmación',
            'Usted cuenta con reuniones coordinadas. ¿Está seguro que desea eliminar las reuniones coordinadas para reunión con el equipo de COMPU?',
            'Sí',
            'No'
          );
          if (deleteResponse) {
            this.model.compuMeetingSchedule.forEach((i) =>
              scheduleOREMeetingApi.remove(i.id)
            );
            this.model.compuMeetingSchedule = [];
          } else {
            this.collapseTogglers.compuMeetingSchedule = true;
          }
        } else {
          alert.methods.ShowToast(
            'Alerta',
            'Usted cuenta con reuniones coordinadas antes de la fecha actual, no es posible descartar la gestión del facilitador de educación especial de la ORE.',
            'error',
            () => (this.collapseTogglers.compuMeetingSchedule = true)
          );
        }
      }
    },
    async deleteCOMPURecommendation(value) {
      if (!value && this.model.compuRecommendations.length > 0) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para recomendar que el COMPU se reúna?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteCOMPURecommendation(
            this.model.id,
            tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisFacilitador
          )
            .then(() => {
              this.model.compuRecommendations = [];
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de COMPU',
                'error',
                () => (this.collapseTogglers.compuRecommendations = true)
              );
            });
        } else {
          this.collapseTogglers.compuRecommendations = true;
        }
      }
    },
    async deleteSchoolRecommendation(value) {
      if (!value && this.model.schoolRecommendations.length > 0) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para el proceso de búsqueda de localizaciones disponibles?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteSchoolRecommendation(this.model.id)
            .then(() => {
              this.model.schoolRecommendations = [];
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de Escuela',
                'error',
                () => (this.collapseTogglers.schoolRecommendations = true)
              );
            });
        } else {
          this.collapseTogglers.schoolRecommendations = true;
        }
      }
    },
    async deleteCSEEConsult(value) {
      if (!value && this.model.cseeDirectorConsult !== null) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para referir consulta al director de CSEE?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteCSEEConsult(this.model.id)
            .then(() => {
              this.model.cseeDirectorConsult = null;
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando la referencia de consulta al director de CSEE',
                'error',
                () => (this.collapseTogglers.cseeDirectorConsult = true)
              );
            });
        } else {
          this.collapseTogglers.cseeDirectorConsult = true;
        }
      }
    },
  },
  watch: {
    'collapseTogglers.cseeDirectorConsult'(value) {
      if (!value) {
        this.$refs['form'].reset();
      }
    },
  },
  async created() {
    await Promise.all([
      this.getCatalogs(),
      this.getData(),
      this.getDocumentTypesByCode('TapRequestFacilitator'),
      this.getPositions(),
    ]);
    this.initTogglers();
    this.setMeetingOptions();
    this.loaded = true;
  },
};
</script>
